<template>
  <section class="partners" aria-labelledby="partners-title">
    <div class="partners-inner">
      <h2 id="partners-title">{{ t('partner.title') }}</h2>
      <div class="partner-grid">
        <div class="partner-card">
          <img src="@/assets/home/particleNetwork.png" alt="Particle Network" loading="lazy" />
        </div>
        <div class="partner-card">
          <img class="jcard-logo" src="@/assets/home/Jcard.png" alt="JCard" loading="lazy" />
        </div>
        <div class="partner-card">
          <img class="redreamer-logo" src="@/assets/home/redreamer.png" alt="ReDreamer" loading="lazy" />
        </div>
        <div class="partner-card">
          <img class="ccube-logo" src="@/assets/home/c-cube.png" alt="C-Cube" loading="lazy" />
        </div>
      </div>
    </div>
  </section>
</template>

<script setup>
import { useI18n } from 'vue-i18n';

const { t } = useI18n();
</script>

<style scoped lang="less">
.partners {
  width: 100%;
  padding: 4.4rem 2.4rem 4.8rem;
  background: #ecf1f9;
}

.partners-inner {
  width: min(120rem, 100%);
  margin: 0 auto;
}

h2 {
  margin: 0 0 2.4rem;
  color: #183b56;
  font-size: 2.8rem;
  font-weight: 700;
  text-align: center;
}

.partner-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 1.8rem;
}

.partner-card {
  display: flex;
  min-height: 9.6rem;
  align-items: center;
  justify-content: center;
  padding: 1.8rem 2.4rem;
  border: 1px solid #e2e8f0;
  border-radius: 1rem;
  background: #fff;
  box-shadow: 0 2px 8px rgb(15 45 68 / 6%);
}

.partner-card img {
  display: block;
  width: auto;
  max-width: 100%;
  height: auto;
  max-height: 5.2rem;
  object-fit: contain;
}

.partner-card .jcard-logo { max-width: 15rem; max-height: 4.8rem; }
.partner-card .redreamer-logo { max-width: 20rem; max-height: 5.6rem; }
.partner-card .ccube-logo { max-width: 18rem; max-height: 4.8rem; }

@media (max-width: 850px) {
  .partner-grid { grid-template-columns: repeat(2, minmax(0, 1fr)); }
}

@media (max-width: 500px) {
  .partners { padding: 3.6rem 1.6rem 4rem; }
  h2 { margin-bottom: 1.8rem; font-size: 2.4rem; }
  .partner-grid { gap: 1.2rem; }
  .partner-card { min-height: 8.4rem; padding: 1.4rem; }
  .partner-card img { max-height: 4.6rem; }
}
</style>
